// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { Button } from '@imprivata-cloud/components';
import { ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import EmptyStateIllustration from '../../../../assets/empty-list.svg';
import { NO_WAVE } from '../constants';
import './ApplicationsEmpty.less';

const TRANSLATION_ROOT = 'apps';

interface ApplicationsEmptyProps {
  onAdd: () => void;
}

const ApplicationsEmpty = ({ onAdd }: ApplicationsEmptyProps) => {
  const { t } = useTranslation();

  return (
    <div className="applications-empty">
      <img src={EmptyStateIllustration} alt="" />
      <p>{t(`${TRANSLATION_ROOT}.empty.title`)}</p>
      <ConfigProvider wave={NO_WAVE}>
        <Button type="link" onClick={onAdd}>
          {t(`${TRANSLATION_ROOT}.empty.add-link`)}
        </Button>
      </ConfigProvider>
    </div>
  );
};

export default ApplicationsEmpty;
